export default __webpack_public_path__ + "media/geo-redirect/styles.css";